import React, { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { cn } from '@src/utils/cn.ts'
import styles from '../Poll.module.scss'
import { PollComponentProps } from './PollComponentType'
import LxCancelButton from '@src/components/cancelButton/LxCancelButton'
import LxSaveButton from '@src/components/saveButton/LxSaveButton'
import { normalizeOptional } from '../Poll'

const mapProperties = (properties: any) => {
  return {
    ...properties,
    btnOk: properties?.btn_ok || 'Ok',
    btnSkip: properties?.btn_skip || 'Skip',
    message: properties?.message || '',
    submessage: properties?.submessage || '',
  }
}

export const PollStatement: React.FC<PollComponentProps> = ({ data, responseCallback }) => {
  const [submitted, setSubmitted] = useState(false)
  const [isOptional, setIsOptional] = useState(false)

  const props = mapProperties(data.properties)

  const onSubmit = (skipped: boolean) => {
    setSubmitted(true)
    responseCallback({
      skipped,
      answer: {}, // Statement doesn’t need an answer payload
    })
  }

  useEffect(() => {
    setSubmitted(false)
    setIsOptional(normalizeOptional(data?.optional))
  }, [data])

  const submessageLines = props.submessage.split('\n') || []

  return (
    <div className={styles.dialogContent}>
      {/* Question/statement */}
      <div className={styles.statementMessage}>
        <Typography variant="h6" component="h6" className={styles.statementHeading}>
          {props.message}
        </Typography>

        {submessageLines.map((line: string, idx: number) => (
          <Typography key={idx} variant="body1" className={styles.statementSubheading}>
            {line}
          </Typography>
        ))}
      </div>

      {/* Actions */}
      <div className={styles.dialogActions}>
        {isOptional && (
          <LxCancelButton
            onCancel={() => onSubmit(true)}
            disabled={submitted}
            label={props.btnSkip}
            classNames={cn(
              'lxActionButton',
              'lxActionButtonDefaultSize',
              styles.pollButton
            )}
          />
        )}

        <LxSaveButton
          disabled={submitted}
          onSubmit={() => onSubmit(false)}
          label={props.btnOk}
          classNames={cn(
            'lxActionButton',
            'lxActionButtonDefaultSize',
            'lxActionButtonFilled',
            styles.pollButton
          )}
        />
      </div>
    </div>
  )
}
